import { doesLogoExists, getCompanyId, getLogoVersion, getCompanyName } from '../lib/Amalgam';

export const createManifestUrl = () => {
  if (
    window.location.pathname.indexOf('/s/review/') !== -1 ||
    window.location.pathname.indexOf('/s/cart/') !== -1 ||
    window.location.pathname.indexOf('/s/resell/') !== -1 ||
    window.location.pathname.indexOf('/profile/my-orders') !== -1 ||
    // eslint-disable-next-line prefer-regex-literals
    window.location.pathname.match(new RegExp('^/[rtuv]/')) !== null
  ) {
    return;
  }

  const queryParams = [
    `companyId=${encodeURIComponent(getCompanyId())}`,
    `companyName=${encodeURIComponent(getCompanyName())}`,
    `logoVersion=${encodeURIComponent(getLogoVersion())}`,
    `logoExists=${encodeURIComponent(doesLogoExists())}`
  ];
  const queryParamsString = `?${queryParams.join('&')}`;

  const linkElement = document.createElement('link');
  linkElement.href = `/manifest${window.location.pathname}${queryParamsString}`;
  linkElement.rel = 'manifest';
  document.getElementsByTagName('head')[0].appendChild(linkElement);
};
